import SectionOne from '@/features/section-1/application/domain/entities/SectionOne';
import { SectionOneSteps } from '@/features/section-1/application/domain/models/section-one-steps';
import { SectionOneForm } from '@/features/section-1/application/validators/section-one.schema';
import { SectionOneFormState } from '@/features/section-1/infra/ui/view-models/useSectionOne';
import Section2 from '@/features/section-2/application/domain/entities/Section2';
import { Section2Steps } from '@/features/section-2/application/domain/models/section-2-steps';
import { Section2Form } from '@/features/section-2/application/validators/section-2.schema';
import { SupplementCoreFields } from '@/features/supplement/infra/repositories/dto/res/SupplementResponseDto';
export enum AmendmentStatus {
  DRAFT = 'DRAFT',
  FINAL = 'FINAL',
}

export class Section1History extends SectionOne {
  constructor(
    formFields: Partial<SectionOneForm>,
    status: SectionOneFormState,
    i9formId: string,
    currentStep: SectionOneSteps
  ) {
    super(formFields, status, i9formId, currentStep);
  }
}

export class Section2History extends Section2 {
  constructor(
    formFields: Partial<Section2Form>,
    i9FormId: string,
    currentStep: Section2Steps,
    eVerifyCaseQueueId: string | null,
    businessName?: string,
    businessAddress?: string,
    savedAt?: string,
    status?: string
  ) {
    super(
      formFields,
      i9FormId,
      currentStep,
      eVerifyCaseQueueId,
      businessName,
      businessAddress,
      savedAt,
      status
    );
  }
}
/** `in_progress`: still open, its snapshot not yet through a Section 2 signature (VTK-2105). */
export type AmendmentVersionState = 'final' | 'in_progress';

/** What produced a version; `update` is any other system-recorded change. */
export type AmendmentVersionKind =
  | 'original'
  | 'section1_amendment'
  | 'section2_amendment'
  | 'ssn_correction'
  | 'supplement_b'
  | 'update';

/** Absent when an older server sent none of them. */
export interface AmendmentVersionMeta {
  state?: AmendmentVersionState;
  kind?: AmendmentVersionKind;
  triggeredAt?: Date;
  closedAt?: Date | null;
}

export class Amendment {
  amendmentStatus: AmendmentStatus;
  amendmentReason: string | null;
  section1History: Section1History | null;
  section2History: Section2History | null;
  supplementBHistory: SupplementCoreFields | null;
  version: AmendmentVersionMeta;

  constructor(
    amendmentStatus: AmendmentStatus,
    amendmentReason: string | null,
    section1History: Section1History | null,
    section2History: Section2History | null,
    supplementBHistory: SupplementCoreFields | null,
    version: AmendmentVersionMeta = {}
  ) {
    this.amendmentStatus = amendmentStatus;
    this.amendmentReason = amendmentReason;
    this.section1History = section1History;
    this.section2History = section2History;
    this.supplementBHistory = supplementBHistory;
    this.version = version;
  }
}
